import { ActionColumnFormat } from './ColumnsFormatters/ActionColumnFormat';
import { StatusColumnFormat } from './ColumnsFormatters/StatusColumnFormat';

export const columns = (onDelete, onEdit, onStatus) => [
	{
		dataField: 'id',
		text: 'Id',
		headerAlign: 'left',
	},
	{
		dataField: 'clave',
		text: 'Clave',
		headerAlign: 'left',
	},
	{
		dataField: 'valor',
		text: 'Valor',
		classes: 'text-center',
		style: { maxWidth: '300px', textAlign: 'center' },
	},
	{
		dataField: 'descripcion',
		text: 'Descripción',
		classes: 'text-center',
		style: { maxWidth: '300px', textAlign: 'center' },
	},
	{
		dataField: 'estatus',
		text: 'Estatus',
		classes: ' text-center',
		formatter: StatusColumnFormat,
	},
	{
		dataField: 'row',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnFormat,
		formatExtraData: {
			onDelete,
			onEdit,
			onStatus,
		},
	},
];

export const defaultFilter = {
	clave: null,
	valor: null,
	descripcion: '',
	estatus: 'A',
};

export const filterForm = (
	onConfirmFilter,
	onClear,
	keyParams = [],
	valueParams = []
) => [
	{
		label: 'Clave',
		name: 'clave',
		type: 'search',
		options: [...keyParams],
		column: 3,
	},
	{
		label: 'Valor',
		name: 'valor',
		type: 'search',
		options: [...valueParams],
		column: 3,
	},
	{
		label: 'Descripción',
		name: 'descripcion',
		type: 'text',
		column: 4,
	},
	{
		label: 'Estatus',
		name: 'estatus',
		type: 'chip-dropdown',
		options: [
			{ value: 'A', text: 'Activo', color: 'primary' },
			{ value: 'I', text: 'Inactivo', color: 'grey' },
		],
		column: 2,
	},
	{
		column: 10,
		type: 'line-break',
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'light-primary',
		type: 'button',
		onClick: onClear,
		column: 1,
	},
	{
		label: 'Buscar',
		name: 'Buscar',
		color: 'info',
		type: 'button',
		column: 1,
		onClick: onConfirmFilter,
	},
];

export const defaultBody = {
	clave: '',
	valor: '',
	descripcion: '',
	estatus: 'A',
};

export const newBodyForm = [
	{
		label: 'Clave',
		name: 'clave',
		type: 'text',
	},
	{
		label: 'Valor',
		name: 'valor',
		type: 'text',
	},
	{
		label: 'Descripción',
		name: 'descripcion',
		type: 'text',
	},
];

export const editForm = [
	{
		label: 'Clave',
		name: 'clave',
		type: 'text',
	},
	{
		label: 'Valor',
		name: 'valor',
		type: 'text',
	},
	{
		label: 'Descripción',
		name: 'descripcion',
		type: 'text',
	},
];
